export const activities = [
    {
        id : "10",
        title:"HOC 2020",
        place:"Tunisian's scout Ariana's headquarter",
        date:"13 December 2020",
        description:`We are extremely delighted to present our homemade masterpiece, the Hour Of Code.
        Hour Of Code is an international event that started as a one-hour introduction to computer science, designed to demystify "code", to show that anybody can learn the basics, and to broaden participation in the field of computer science.`,
        details:`The event was held on Sunday the 13th of December 2020 at The Tunisian's scout Ariana's headquarter.
        Even though we would never be able to transmit all the positive energy we felt and all the passion we encountered while being with those smart kids, we could make a sweet summary of it. Being close to those kinds and leading them through their first steps in the world of coding is an absolute honor .
        We, the IEEE Computer Society  family, are so grateful to every single person who contributed to make this event successful,  unique, and filled with love.`,
        images:["hoc/hoc1.webp","hoc/hoc3.webp"],
        facebookUrl:"https://www.facebook.com/INSAT.CS/posts/3411677918940811",
        instagramUrl:"https://www.instagram.com/p/CIv6IK8nmXt/"
    },
    {
        id : "9",
        title:"BI Workshops",
        place:"Online",
        date:"13 November 2020",
        description:"On Friday, the 13th of November 6pm, and for the 1st time in the history of the IEEE Computer Society INSAT SB, we are hosting our Business Intelligence workshop held by the talented trainer Mohamed Mokhtar.",
        details:`On Friday, the 13th of November 6pm, and for the 1st time in the history of the IEEE Computer Society INSAT SB, we are hosting our Business Intelligence workshop held by the talented trainer Mohamed Mokhtar.`,
        images:["bi/BI.webp"],
        facebookUrl:"https://www.facebook.com/INSAT.CS/posts/3334143970027540",
        instagramUrl:"https://www.instagram.com/p/CHYYbUeqzLg/"
    },
    {
        id : "8",
        title:"Mobile Application Project",
        place:"Online",
        date:"10 November 2020",
        description:"We noticed our members interest and thrive to participate in the execution of projects and willingness to prove their talents and skills",
        details:`This was our main reason to come up with the idea of our first project of this year! The idea consists of building a mobile application using Flutter mainly to be your IEEE INSAT SB guide. While accessing the app, you will be able to navigate through all the chapters and keep yourselves updated about their latest activities and events.This project is going to mark your names in the IEEE INSAT SB history forever.
        Link for the specification requirements of the application`,
        images:["mobile_project/Mobile.webp"],
        facebookUrl:"https://www.facebook.com/Data-Overflow-110931427006449",
        instagramUrl:"https://www.facebook.com/INSAT.CS/posts/3325817557526848"
    },
    {
        id : "7",
        title:"Data Overflow Workshops",
        place:"Online",
        date:"4 November 2020",
        description:"DataOverflow is a collaboration between IEEE CS INSAT SB Chapter and ACM INSAT.",
        details:`DO is a cycle of training sessions that will be concluded with a three-days conference featuring a number of contests and lectures revolving around the topics of Data Science and AI.`,
        images:["do/do.webp"],
        facebookUrl:"https://www.facebook.com/Data-Overflow-110931427006449",
        instagramUrl:"https://www.instagram.com/dataoverflow_/?hl=en"
    },
    {
        id : "2",
        title:"Mobile Development Workshops",
        place:"Online",
        date:"28 October 2020 and 4 November 2020",
        description:"The Mobile Application Development workshops are led by our Trainer Mohamed Ali Jardak, using the " +
            "toolkit Flutter to learn the principles of mobile application design and development",
        details:"Flutter is Google’s UI toolkit for building beautiful, natively compiled applications for mobile, web, " +
            "and desktop from a single codebase. These workshops will take place on the 28th of October and on the 4th of" +
            " November from 7 PM to 9 PM.\n" +
            "Because we thought about your safety, we decided to keep it online so that you can learn in the comfort of your own homes.\n",
        images:["flutter/1.webp","flutter/2.webp"],
        facebookUrl:"https://www.facebook.com/INSAT.CS/posts/3288221794619758",
        instagramUrl:"https://www.instagram.com/p/CG29489HUXw/"
    },
    {
        id : "6",
        title:"IEEEXtreme 14.0 1st place in Tunisia Winners",
        place:"Online",
        date:"24 October 2020",
        description:"IEEEXtreme is a global challenge in which teams of IEEE Student members compete in 24 hours against" +
            " each other to solve a set of programming problems",
        details:"We had a total of 4 teams coming from INSAT ranking in the top 7 teams in the whole country! Let’s " +
            "congratulate: NPBOSTAGI, GreenForTheWin, VertexCover & LASTPLACE. The number one team is: NPBOSTAJI whose " +
            "members are: Helmi Boudhraa, Marouene Sfar Ghandoura & Ahmed Neji. This team is ranked 31 IN THE WHOLE WORLD!" +
            " We are so glad that it was a total success and that we managed to beat the quarantine vibes with the INSATian" +
            " spirit, ranked number ️1 always.\n",
        images:["xtreme/1.webp","xtreme/2.webp","xtreme/3.webp","xtreme/4.webp"],
        facebookUrl:"https://www.facebook.com/INSAT.CS/posts/3281038122004792",
        instagramUrl:"https://www.instagram.com/p/CGxYLRWqkEQ/"
    },
    {
        id : "5",
        title:"UMOJAHACK Tunisia 2nd place Winners",
        place:"Online",
        date:"17 October 2020",
        description:"UmojaHack Tunisia inter-university Hackathon, hosted by Zindi and InstaDeep Ltd where 252 participants," +
            " representing 15 universities and engineering schools in Tunisia, given a sequence of amino acids, had to " +
            "predict protein kinase classes",
        details:"The participants from INSAT showed a huge amount of enthusiasm and energy, and one of our participant " +
            "teams obtained 2nd Place. The winning team is the GL4 team, whose members are: Ahmed Attia, Mehdi Mabrouki," +
            " Aziz Belaweid, and Mokhtar Mami. The team earned 825 TND, added to the 2750 TND for the university. Their " +
            "approach consisted of using Stratified cross-validation with focal loss due to the imbalance of data along " +
            "with bidirectional LSTM/GRU and finally ensembling using geometric mean." +
            "Because we thought about your safety, we decided to keep it online so that you can learn in the comfort of your own homes.\n",
        images:["umojahack/1.webp","umojahack/2.webp","umojahack/3.webp"],
        facebookUrl:"https://www.facebook.com/INSAT.CS/posts/3264036333704971",
        instagramUrl:"https://www.instagram.com/p/CGIjwr0HN7C/"
    },
    {
        id : "4",
        title:"IEEE Day",
        place:"INSAT",
        date:"14 October 2020",
        description:"The IEEEDAY, where we can celebrate the IEEE creation ",
        details:"Since we believe in the power of the team, we always start the year by offering students from our institute" +
            " the opportunity to join our big family. Therefore, IEEEDay is an occasion to make them feel welcomed and " +
            "motivated, show them what they can achieve with us, and try our best to make them believe that this is a place" +
            " where they belong and contribute.",
        images:["ieeeDay/1.webp","ieeeDay/2.webp"],
        facebookUrl:"https://www.facebook.com/IeeeInsatStudentBranch/posts/3508280742543803",
        instagramUrl:"https://www.instagram.com/p/CGSs2Uvn3f2/"
    },
    {
        id : "3",
        title:"Summer School",
        place:"INSAT",
        date:"2-3-4 October 2020",
        description:"Summer School: 1st event and our welcoming gift",
        details:"Summer school, organized by the IEEE INSAT Student Branch, is a way to turn students' summer into a productive one.\n" +
            "We, as the Computer Society Chapter, try to offer the students through this event multiple pieces of training" +
            " in several domains such as Python programming, web development, and others. Thus, it is a great opportunity" +
            " to get introduced to modern development and design technologies.\n",
        images:["summerSchool/1.webp","summerSchool/2.webp","summerSchool/3.webp"],
        facebookUrl:"https://www.facebook.com/IeeeInsatStudentBranch/photos/a.3479851318720079/3479853735386504/",
        instagramUrl:"https://www.instagram.com/p/CF73gDOHz9b/"
    },


];
